import { useBreakpoints, breakpointsTailwind, useMediaQuery } from '@vueuse/core'

// ---------------------------------------------------------------------------
// App-wide responsive breakpoints, aligned to Tailwind's defaults.
// See .claude/rules/responsive-ui.md for the full breakpoint system.
//
// The app shell switches from the mobile bottom-nav layout to the sidebar
// layout at `md` (768px):
//   • < md  (isMobile)  → phone: slim top bar + fixed bottom tab bar
//   • md–lg (isTablet)  → tablet portrait: sidebar shell, defaults collapsed
//   • ≥ lg  (isDesktop) → desktop: sidebar respects the saved user preference
//
// Defined once at module scope so every consumer shares the same matchMedia
// listeners rather than creating new ones per component.
// ---------------------------------------------------------------------------
const breakpoints = useBreakpoints(breakpointsTailwind)

const isMobile     = breakpoints.smaller('md')        // < 768
const isTablet     = breakpoints.between('md', 'lg')   // 768–1023
const isDesktop    = breakpoints.greaterOrEqual('lg')  // ≥ 1024
const isTouchDevice = useMediaQuery('(hover: none)')   // true on phones/tablets (primary input can't hover)

export function useResponsive() {
  return { breakpoints, isMobile, isTablet, isDesktop, isTouchDevice }
}
